module.exports = __webpack_public_path__ + "img/icon_camera.f730f57d.svg";